import { useCustomContext } from '../../showcase-react';

import { Path } from './types';

type To = string | Partial<Path>;

type RelativeRoutingType = 'route' | 'path';

interface NavigateOptions {
  replace?: boolean;
  state?: any;
  preventScrollReset?: boolean;
  relative?: RelativeRoutingType;
}

interface NavigateFunction {
  (to: To, options?: NavigateOptions): void;
  (delta: number): void;
}

export function useNavigation(): NavigateFunction {
  const context = useCustomContext();
  const navigate = context?.router?.navigate ?? {};

  return navigate;
}
